const NOTIFICATION_TIMEOUT = 15000;

const UNSUPPORTED_COLUMNS = [
  // Connected board: "board-relation" is the legacy name some older boards still
  // report, "board_relation" the current one (API 2025-04) — block both.
  "board-relation",
  "board_relation",
  // Mirror: "lookup" on older boards, "mirror" on current ones — block both.
  "lookup",
  "mirror",
  "dependency",
  "formula",
  "item_id",
  "creation_log",
  "progress",
  "last_updated",
  "time_tracking",
  "color_picker",
  // File columns are supported since the file-column feature: the editor
  // uploads files (lib/files) and the server copies them on apply.
  "doc",
];
const COLUMN_TYPE_NAME_MISMATCHES = {
    "color":"status",
    "multiple-person":"people",
    "numeric":"numbers",
    "timerange":"timeline",
    "long-text":"long_text",
    "autonumber":"auto_number",
    "timezone":"world_clock",
    "pulse-id":"item_id",
    "pulse-log":"creation_log",
    "pulse-updated":"last_updated",
    "columns-battery":"progress",
    "duration":"time_tracking",
    "color-picker":"color_picker",
    "tag":"tags",
    "boolean":"checkbox",
    "votes":"vote"
};

/**
 * Collapse monday's two naming generations onto ONE key.
 *
 * COLUMN_TYPE_NAME_MISMATCHES maps legacy names to current ones
 * (color→status, multiple-person→people, numeric→numbers, timerange→timeline,
 * boolean→checkbox, long-text→long_text, ...). The API version this app pins
 * (2025-04) returns the CURRENT names, while templates saved by older versions
 * of the app stored the LEGACY ones — so anything switching on a column type
 * must canonicalize first or it silently mishandles half the types.
 *
 * Canonical form = the current monday name.
 */
const canonicalType = (type) => COLUMN_TYPE_NAME_MISMATCHES[type] ?? type;

const isSupportedColumn = (type) => {
    // canonicalize so legacy aliases of unsupported types (pulse-log,
    // columns-battery, duration, ...) are rejected too
    const kind = canonicalType(type);
    return !UNSUPPORTED_COLUMNS.includes(kind);
}

export {
    NOTIFICATION_TIMEOUT,
    isSupportedColumn,
    canonicalType,
    COLUMN_TYPE_NAME_MISMATCHES
};